import { Reply } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  IconButton,
  Typography
} from '@mui/material';
import { useContext, useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import AuthContext from '../contexts/auth';
import { DateInfo } from '../global/datetime';

function cmpTimeStr(a, b) {
  return new Date(b) - new Date(a);
}

export default function NewsPage() {
  const [accountId] = useContext(AuthContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const [invitations, setInvitations] = useState(null);
  const [belongingProjects, setBelongingProjects] = useState(null);
  const [followingProjects, setFollowingProjects] = useState(null);
  const [followingAccountsPosts, setFollowingAccountsPosts] = useState(null);
  const [taskWrappers, setTaskWrappers] = useState([]);
  const tasksCounter = useRef(0);
  const [belongingPosts, setBelongingPosts] = useState([]);
  const belongingPostsCounter = useRef(0);
  const [followingPosts, setFollowingPosts] = useState([]);
  const followingPostsCounter = useRef(0);

  // taskWrapper와 postWrapper들이 들어간다.
  const [units, setUnits] = useState(null);

  useEffect(() => {
    // 프로젝트 초대장
    fetch(`${process.env.REACT_APP_API_URL}/api/accounts/project-invitation`)
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        setInvitations(res);
      });

    // 속한 프로젝트
    fetch(`${process.env.REACT_APP_API_URL}/api/projects/accounts/${accountId}`)
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        setBelongingProjects(res);
      });

    // 팔로우 프로젝트
    fetch(`${process.env.REACT_APP_API_URL}/api/accounts/${accountId}/following-projects`)
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        setFollowingProjects(res);
      });

    // 나의 팔로워의 게시물
    fetch(`${process.env.REACT_APP_API_URL}/api/posts/following-accounts`)
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        setFollowingAccountsPosts(res);
      });
  }, []);

  useEffect(() => {
    if (!belongingProjects) {
      return;
    }

    // 테스크
    // 프로젝트 단위로 받는데,
    // 최신 (7일 이내? 기준시간값을 변경하기 쉽게 구현하세요)측에 속하는 것만 가지고 나머지는 날린다. (이러고 남은게 없으면 패스~)
    // 정렬 후 포장해서 저장한다.
    belongingProjects.forEach((project) => {
      fetch(`${process.env.REACT_APP_API_URL}/api/projects/${project.id}/tasks`)
        .then((res) => res.json())
        .then((res) => {
          console.log(res);
          // 최신 항목 분리 (7일 이내의 항목)
          const filteredTasks = res.filter((task) => {
            const deltaTime = Date.now() - new Date(task.updateTimeStr);
            return deltaTime <= 7 * 24 * 60 * 60 * 1000;
          });

          if (filteredTasks.length > 0) {
            filteredTasks.sort((a, b) => cmpTimeStr(a.updateTimeStr, b.updateTimeStr));
            const taskWrapper = {
              type: 'TASKS',
              tasks: filteredTasks,
              project,
              wrapperTime: filteredTasks[0].updateTime,
              wrapperTimeStr: filteredTasks[0].updateTimeStr,
            };
            setTaskWrappers((prev) => [...prev, taskWrapper]);
          }
          setTaskWrappers((prev) => [...prev]);
          tasksCounter.current += 1;

          // if (res.length > 0) {
          //   const curTaskWrappers = [];
          //   res.forEach((task) => {
          //     curTaskWrappers.push({
          //       type: 'TASKS',
          //       tasks: [task],
          //       project,
          //       wrapperTime: task.updateTime,
          //       wrapperTimeStr: task.updateTimeStr,
          //     });
          //   });
          //   setTaskWrappers((prev) => [...prev, ...curTaskWrappers]);
          // }
          // tasksCounter.current += 1;
        });
    });

    // 게시물
    // 프로젝트 단위로 받는데, 딱히 구분하진 않는다.
    // 상태변수에 추가한다. (정렬은 나중에 한번에)
    belongingProjects.forEach(({ id }) => {
      fetch(`${process.env.REACT_APP_API_URL}/api/posts/project/${id}`)
        .then((res) => res.json())
        .then((res) => {
          console.log(res);
          // TODO : 최신 항목 분리 (안해도될듯)
          setBelongingPosts((prev) => [...prev, ...res.content]);
          belongingPostsCounter.current += 1;
        });
    });
  }, [belongingProjects]);

  useEffect(() => {
    if (!followingProjects) {
      return;
    }

    // 게시물
    // 프로젝트 단위로 받는데, 딱히 구분하진 않는다.
    // 상태변수에 추가한다. (정렬은 나중에 한번에)
    followingProjects.forEach(({ id }) => {
      fetch(`${process.env.REACT_APP_API_URL}/api/posts/project/${id}`)
        .then((res) => res.json())
        .then((res) => {
          console.log(res);
          // TODO : 최신 항목 분리 (안해도될듯)
          setFollowingPosts((prev) => [...prev, ...res.content]);
          followingPostsCounter.current += 1;
        });
    });
  }, [followingProjects]);

  useEffect(() => {
    console.log(invitations === null);
    console.log(belongingProjects === null);
    console.log(tasksCounter.current !== belongingProjects?.length);
    console.log(belongingPostsCounter.current !== belongingProjects?.length);
    console.log(followingProjects === null);
    console.log(followingPostsCounter.current !== followingProjects?.length);
    console.log(followingAccountsPosts === null);
    if (
      invitations === null ||
      belongingProjects === null ||
      tasksCounter.current !== belongingProjects.length ||
      belongingPostsCounter.current !== belongingProjects.length ||
      followingProjects === null ||
      followingPostsCounter.current !== followingProjects.length ||
      followingAccountsPosts === null
    ) {
      return;
    }

    // 중복 포스트를 날리고, Wrapping 하기
    const postWrappers = [];
    const checker = {};
    [...belongingPosts, ...followingPosts, ...followingAccountsPosts].forEach(
      (post) => {
        if (checker[post.id]) {
          return;
        }
        checker[post.id] = true;
        postWrappers.push({
          type: 'POST',
          post,
          project: post.project,
          wrapperTime: post.writeTime,
          wrapperTimeStr: post.writeTimeStr,
        });
      },
    );

    // wrapper 통합 및 정렬
    const wrappers = [...taskWrappers, ...postWrappers];
    wrappers.sort((a, b) => cmpTimeStr(a.wrapperTimeStr, b.wrapperTimeStr));
    // 개수를 잘라낸다?? (일단은 ㅇㅇ!)
    if (wrappers.length > 20) {
      wrappers.length = 20;
    }

    setUnits(wrappers);
    setIsLoaded(true);
    console.log(invitations);
  }, [
    invitations,
    belongingProjects,
    followingProjects,
    taskWrappers,
    belongingPosts,
    followingPosts,
    followingAccountsPosts,
  ]);

  // == render ========
  if (!isLoaded) {
    return (
      <Template bgcolor="#F8F8F8">
        <Box display="flex" alignItems="center">
          <CircularProgress />
          <Box width="1rem" />
          <Typography>최근 소식을 가져오고 있습니다...</Typography>
        </Box>
      </Template>
    );
  }

  return (
    <Template bgcolor="#F8F8F8">
      {invitations.length === 0 &&
        invitations.length === 0 &&
        units.length === 0 ? (
        <>
          <Typography variant="h3" color="primary">
            😅 최근 소식이 없네요...
          </Typography>
          <Box height="1rem" />
          <Divider />
          <Box height="1rem" />
          <Typography variant="body1" align="center">
            프로젝트에 참여해서 여정을 기록해보세요!
          </Typography>
          <Box height="1rem" />
        </>
      ) : (
        <>
          <Typography variant="h3" color="primary">
            🥳 최근 소식
          </Typography>
          <Box height="1rem" />
          <Divider />
          <Box height="1rem" />
        </>
      )}

      {invitations.map((invitation) => (
        <InvitationsCard key={invitation.id} invitation={invitation} />
      ))}

      {units.map((wrapper) => {
        switch (wrapper.type) {
          case 'POST':
            return (
              <PostCard key={`POST_${wrapper.post.id}`} postWrapper={wrapper} />
            );
          case 'TASKS':
            return (
              <TasksCard
                key={`TASKS_${wrapper.project.id}`}
                tasksWrapper={wrapper}
              />
            );
          default:
            return null;
        }
      })}
      <Divider />
    </Template>
  );
}

// == 이하 중요하지 않음 ========
function InvitationsCard({ invitation }) {
  const { projectId, projectName, id: joinId } = invitation;
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);

  async function accept() {
    setIsLoading(true);
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/project-joins/${joinId}`, {
      method: 'POST',
    });
    if (res.status >= 200 && res.status < 300) {
      setMessage('초대를 수락하였습니다.');
      setIsLoading(false);
    }
  }

  async function reject() {
    setIsLoading(true);
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/project-joins/${joinId}`, {
      method: 'DELETE',
    });
    if (res.status >= 200 && res.status < 300) {
      setMessage('초대를 거절하였습니다.');
      setIsLoading(false);
    }
  }

  return (
    <UnitCard>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography variant="caption" color="textSecondary">
            프로젝트 초대
          </Typography>
          <Typography variant="body1">
            <CustomLink to={`/projects/${projectId}`}>{projectName}</CustomLink>
            에 초대되었습니다.
          </Typography>

          <Box marginLeft="0.5rem" marginTop="0.5rem" display="flex">
            {(() => {
              if (isLoading) {
                return <CircularProgress />;
              }

              if (message) {
                return (
                  <Typography variant="body1" color="textSecondary">
                    {message}
                  </Typography>
                );
              }

              return (
                <>
                  <Button
                    onClick={accept}
                    variant="contained"
                    disableElevation
                    color="primary"
                  >
                    수락
                  </Button>
                  <Button
                    onClick={reject}
                    variant="contained"
                    disableElevation
                    style={{ marginLeft: '0.5rem' }}
                  >
                    거절
                  </Button>
                </>
              );
            })()}
          </Box>
        </Box>
        <IconButton
          onClick={() => {
            history.push(`/projects/${projectId}`);
          }}
        >
          <Reply />
        </IconButton>
      </Box>
    </UnitCard>
  );
}

function TasksCard({ tasksWrapper }) {
  const { project, wrapperTime, tasks } = tasksWrapper;
  const mainTask = tasks[0]; // { status, updateTime, ... }
  const history = useHistory();

  return (
    <UnitCard>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="" color="primary">
            <CustomLink to={`/projects/${project.id}`}>
              {project.name}
            </CustomLink>
          </Typography>
          &nbsp;
          <DateInfo dateTime={wrapperTime} />
          <Box height="1rem" />
          <Box display="flex" alignItems="center">
            <CustomLink to={`/projects/${project.id}/task`}>
              <SmallCard>
                <span
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '1rem',
                    padding: '0.25rem',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <CustomEm>
                    {(() => {
                      switch (mainTask.status) {
                        case 0:
                          return '진행 전';
                        case 1:
                          return '진행 중';
                        case 2:
                          return '완료';
                        case 3:
                          return '실패';
                        default:
                          return null;
                      }
                    })()}
                  </CustomEm>
                </span>
                &nbsp;{mainTask.taskName}
              </SmallCard>
            </CustomLink>
            <Box marginLeft="0.25rem">
              <CustomLink to={`/projects/${project.id}/task`}>
                <CustomEm>등 {tasks.length}건의 태스크</CustomEm>
              </CustomLink>
              가 업데이트 되었습니다.
            </Box>
          </Box>
        </Box>
        <IconButton
          onClick={() => {
            history.push(`/projects/${project.id}/task`);
          }}
        >
          <Reply />
        </IconButton>
      </Box>
    </UnitCard>
  );
}

function PostCard({ postWrapper }) {
  const { project, wrapperTime, post } = postWrapper;
  const history = useHistory();

  return (
    <UnitCard>
      <Typography variant="" color="primary">
        <CustomLink to={`/projects/${project.id}`}>{project.name}</CustomLink>
      </Typography>
      &nbsp;
      <DateInfo dateTime={wrapperTime} />
      <Box height="1rem" />
    </UnitCard>
  );
}

function UnitCard({ children }) {
  return (
    <>
      <Card>
        <Box padding="1rem">{children}</Box>
      </Card>
      <Box marginBottom="1rem" />
    </>
  );
}

function SmallCard({ children }) {
  return (
    <Box
      bgcolor="#593875"
      color="white"
      padding="0.5rem"
      borderRadius="1rem"
      lineHeight="1.75rem"
    >
      {children}
    </Box>
  );
}

// //////////////////
function Template({ children, ...props }) {
  return (
    <>
      <Box maxWidth="768px" margin="2rem auto" {...props}>
        <Box padding="1rem">{children}</Box>
      </Box>
      <Box height="6rem" />
    </>
  );
}

function CustomLink({ children, ...props }) {
  return (
    <Link style={{ color: '#593875', textDecoration: 'none' }} {...props}>
      {children}
    </Link>
  );
}

function CustomEm({ children }) {
  return <strong style={{ color: '#593875' }}>{children}</strong>;
}
